import { UserCredentials } from './wpAuth';

type Method = 'GET' | 'POST' | 'DELETE';

interface RequestOptions {
    auth?: UserCredentials;
    body?: unknown;
    headers?: Record<string, string>;
    method?: Method;
}

const buildHeaders = (opts?: RequestOptions): HeadersInit => {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json'
    };
    if (opts?.headers) {
        Object.assign(headers, opts.headers);
    }
    if (opts?.auth) {
        const encoded = btoa(opts.auth.user_login + ':' + opts.auth.password);
        headers['Authorization'] = `Basic ${encoded}`;
    }
    return headers;
};

async function request<T>(url: string, opts?: RequestOptions): Promise<T> {
    const res = await fetch(url, {
        method: opts?.method ?? 'GET',
        credentials: 'omit',
        headers: buildHeaders(opts),
        body: opts?.body !== undefined ? JSON.stringify(opts.body) : undefined,
    });
    if (!res.ok) {
        throw await safeJson(res);
    }
    return await res.json();
}

async function safeJson(res: Response) {
    try { return await res.json(); } catch { return { status: res.status, statusText: res.statusText }; }
}

export const http = {
    get: <T>(url: string, opts?: RequestOptions) => request<T>(url, { ...opts, method: 'GET' }),
    post: <T>(url: string, body?: unknown, opts?: RequestOptions) => request<T>(url, { ...opts, method: 'POST', body }),
    /** DELETE may include `body` in opts (e.g. birds-push unsubscribe). */
    del: <T>(url: string, opts?: RequestOptions) => request<T>(url, { ...opts, method: 'DELETE' }),
    getWithHeaders: async <T>(url: string, opts?: RequestOptions): Promise<{ data: T, headers: Headers }> => {
        const res = await fetch(url, { method: 'GET', credentials: 'omit', headers: buildHeaders(opts) });
        if (!res.ok) {
            throw await safeJson(res);
        }
        const data = await res.json();
        return { data, headers: res.headers };
    }
};


